import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, filter, startWith } from 'rxjs';
import { SidePanelPages } from 'src/_models/panels';

@Injectable({
  providedIn: 'root'
})
export class SidePanelService {

  private currPage: SidePanelPages;
  onPageChange: Subject<SidePanelPages> = new Subject();

  constructor(
    private router: Router
  ) {
    this.subscribePageChange();
  }

  subscribePageChange() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(
      event => {
        const _url = this.router.url?.split("?")[0]?.toLocaleLowerCase();

        if(_url.startsWith('/policy')) {
          this.currPage = SidePanelPages.INSURANCEPAGE;
        }
        else if (_url.startsWith('/survey')) {
          this.currPage = SidePanelPages.SURVEY;
        }
        else {
          switch(_url) {
            case '/':
              this.currPage = SidePanelPages.HOMEPAGE;
              break;
  
            case '/directsearch':
              this.currPage = SidePanelPages.DIRECTSEARCH;
              break;
  
            default: 
              this.currPage = SidePanelPages.DEFAULT;
              break;
          }
        }
        
        this.onPageChange.next(this.currPage);
      }
    )
  }  
  
}
